module.exports = __webpack_public_path__ + "img/phone.c2cc21f0.png";